import { Component, AfterViewInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ToastContainerComponent } from './shared/toast/toast-container/toast-container.component';
import { ErrorNotificationService } from './shared/error/services/error-notification.service';
import { ViewChild } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],

  standalone: false,})
export class AppComponent implements AfterViewInit {
  title = 'caaks';
  @ViewChild('toastContainer') toastContainer!: ToastContainerComponent;

  constructor(private errorNotifier: ErrorNotificationService) {
    this.title = environment.applicationTitle;
  }

  ngAfterViewInit(): void {
    this.errorNotifier.toast$.subscribe(config => {
      if (this.toastContainer) {
        this.toastContainer.show(config);
      }
    });
  }
}
